export const COMMUNITY_ROLES = {
  COMMUNITY_MANAGER: 'community_manager',
  COMMUNITY_MEMBER: 'community_member',
};

export const COMMUNITY_ROLES_LABELS = {
  [COMMUNITY_ROLES.COMMUNITY_MANAGER]: 'Community Manager',
  [COMMUNITY_ROLES.COMMUNITY_MEMBER]: 'Community Member',
};
